import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand, faXmark } from "@fortawesome/free-solid-svg-icons";
import { setActiveConversation } from "../../Slices/chatSlice";
import { openWindow } from "../../Slices/windowsSlice";
import ChatSidebar from "../../views/pages/Chat/ChatSidebar";
import ChatWindow from "../../views/pages/Chat/ChatWindow";

/**
 * ChatFlyout — the tray flyout that surfaces chat in the Webtop, opened from the
 * chat icon in the SystemTray (sibling of the notifications bell).
 *
 * Reuses the SAME inner components the legacy floating ChatWidget uses
 * (ChatSidebar conversation list + ChatWindow), so behaviour/data is identical —
 * only the entry point moves from a floating FAB to a Windows-11 tray icon.
 * The shared ChatWidget is left untouched (Rule 4); the webtop simply does not
 * render it (see WebtopGlobalListeners) and uses this tray-native surface.
 *
 * "Expand" opens the full Chat as a webtop WINDOW (mirrors NotificationsPanel's
 * openWindow); "back" clears the active conversation (mirrors ChatWidget).
 */
const ChatFlyout = ({ onClose }) => {
  const dispatch = useDispatch();
  const activeConversationId = useSelector((s) => s.chat?.activeConversationId);

  const handleExpand = () => {
    dispatch(openWindow({ path: "/chat", title: "Chat" }));
    onClose();
  };

  const handleBack = () => dispatch(setActiveConversation(null));

  return (
    <div className="webtop-flyout webtop-chat-flyout" role="dialog" aria-label="Messages">
      <div className="webtop-chat-flyout__head">
        <span className="webtop-chat-flyout__title">Messages</span>
        <div className="webtop-chat-flyout__actions">
          <button
            type="button"
            className="webtop-chat-flyout__btn"
            onClick={handleExpand}
            title="Open in a window"
            aria-label="Open chat in a window"
          >
            <FontAwesomeIcon icon={faExpand} />
          </button>
          <button
            type="button"
            className="webtop-chat-flyout__btn"
            onClick={onClose}
            title="Close"
            aria-label="Close messages"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      </div>

      <div className="webtop-chat-flyout__body">
        {activeConversationId ? (
          <ChatWindow mode="widget" onBack={handleBack} />
        ) : (
          <ChatSidebar mode="widget" onConversationSelect={() => {}} />
        )}
      </div>
    </div>
  );
};

export default ChatFlyout;
